import { render } from "./forceupgradeadd.vue?vue&type=template&id=1ab78977&scoped=true"
import script from "./forceupgradeadd.vue?vue&type=script&lang=js"
export * from "./forceupgradeadd.vue?vue&type=script&lang=js"

import "./forceupgradeadd.vue?vue&type=style&index=0&id=1ab78977&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab78977"]])

export default __exports__